module Meevo.Plugins.AlertsManager {

    import IAlertJSON = Meevo.Model.IAlertJSON;

    interface IAmountOfTimeAlertJson extends IAlertJSON {
        daysLimit: number;
        repeatDay: number;
    }

    class MeevoAmountOfTimeComponent extends BaseConfigComponent implements ng.IComponentController {

        static $inject = [
            '$translate',
            'meevo.plugins.alertsManager.AlertsManagerService'
        ];

        constructor(
            protected $translate: angular.translate.ITranslateService,
            protected alertsManagerService: IAlertsManagerService
        ) {
            super(alertsManagerService);
        }

        public params: IParams;
        public data: any;

        public settings: IAmountOfTimeAlertJson = {
            daysLimit: 1,
            repeatDay: 1
        };

        get dataForReview() {
            return [
                this.$translate.instant('QUICKBOOKS_INTEGRATION_HAS_NOT_BEEN_SYNCED_IN') + ' ' + this.settings.daysLimit + ' ' + this.$translate.instant('LABEL_DAY(S)'),
                this.$translate.instant('QUICKBOOKS_INTEGRATION_ALERT_WILL_BE_SENT_EVERY') + ' ' + this.settings.repeatDay + ' ' + this.$translate.instant('DAYS_AFTER_THE_FIRST_ALERT').toLowerCase()
            ];
        }

        get alertConfiguration() {
            return this.settings;
        }

        onEdit(alertJSON: IAmountOfTimeAlertJson): void {
            this.settings = alertJSON;
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoAlertManagerAmountOfTimeConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/amount-of-time-config/amount-of-time-config.component.html',
            controller: MeevoAmountOfTimeComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<'
            }
        });
}